import React from "react";

import { useSelector, useDispatch } from "react-redux";
import { dot, editIcon } from "../../../Shared/SVGs/Shared";

const line = <div className="line"></div>;

const StepIndecator = ({ editHandler, editable }) => {
  const activeStep = useSelector((state) => state.campaign_states.activeStep);
  const totalSteps = useSelector((state) => state.campaign_states.totalSteps);
  const dispatch = useDispatch();
  const showCampaignStep = useSelector(
    (state) => state.videoPageStates.campaignsState.showCampaignStep
  );

  return (
    <div style={{ position: "relative" }} className="campaign-header">
      {/* <div className="d-flex justify-content-between align-items-baseline mt-3"> */}
      {!showCampaignStep && (
        <div
          className="d-flex gap-1 align-items-center dots"
          style={{ justifyContent: activeStep === 5 && "center" }}
        >
          {[...Array(totalSteps)].map((_, index) => (
            <React.Fragment key={index}>
              {index > 0 && line}
              {index < activeStep ? <span className="active-dot"></span> : dot}
            </React.Fragment>
          ))}
        </div>
      )}

      {activeStep !== 5 && (
        <div className="my-3 detail-header">
          <div className="detail-text">
            <div className="d-flex align-items-center gap-2">
              <div>
                {" "}
                <img
                  // role="button"
                  src={
                    activeStep === 4
                      ? require(`@src/assets/images/vyrill/campaign-tool/previewIcon.png`)
                          .default
                      : require(`@src/assets/images/vyrill/campaign-tool/campaign_icon.png`)
                          .default
                  }
                  style={{
                    position: "absolute",
                    left: "-60px",
                    top: showCampaignStep ? "20px" : "60px",
                  }}
                  width={35}
                />
                <div
                  className="d-flex justify-content-between align-items-center"
                  style={{ width: "600px" }}
                >
                  <div className="detail">
                    {activeStep === 4 ? (
                      <div>
                        Campaign Details - Mobile Preview
                        <div
                          style={{
                            fontSize: "13px",
                            lineHeight: "36px",
                            fontWeight: "300",
                            color: "#575F6E",
                          }}
                        >
                          As participants will view the campaign in their mobile
                          phone
                        </div>
                      </div>
                    ) : (
                      "Campaign Details"
                    )}
                  </div>
                  {activeStep === 4 && (
                    <div onClick={editHandler} role="button">
                      {editable ? (
                        <div className="done">Save</div>
                      ) : (
                        <div>{!showCampaignStep && editIcon}</div>
                      )}
                    </div>
                  )}
                </div>
              </div>
            </div>

            <p className="mt-1">
              {activeStep !== 4 &&
                "The details you enter here will be visible to the public once the campaign is launched."}
            </p>
          </div>
        </div>
      )}
    </div>
  );
};

export default StepIndecator;
